import { AdviserResponse } from "./adviserResponse";
import { MessageResponse } from "./messageResponse";

export class AdvisersResponse extends MessageResponse {
    advisers: Array<AdviserResponse>
}
